export function simplifyKeys(obj: Record<string, unknown>){
  return Object.entries(obj).map(([key]) => key.replace(/\/assets\//g, "/"));
}

export function getBaseFileName(path: string){
  const fileNameWithExtension = path.split("/").pop();
  return fileNameWithExtension?.split(".").slice(0, -1).join(".") || "";
}
